import { graphql } from 'react-relay';

export const awardsListItemFragment = graphql`
    fragment AwardsListItem_awardsListItem on AwardsListItem {
        year
        logoUrl
        awardName
        awardText
    }
`;
